import React from "react";
import { useTranslation } from "react-i18next";
import { Transfer } from "misc/transfer";
import { useApps } from "misc/api/keycloakApi";

const AppTransfer = ({ value, onChange, ...props }) => {
    const [t] = useTranslation();
    const { apps } = useApps({ suspense: true });

    return (
        <Transfer
            dataSource={apps.map(app => ({
                key: app,
                title: t(`t_app_${app}`)
            }))}
            filterOption={(inputValue, option) => {
                return option.title.toLowerCase().includes(inputValue.toLowerCase());
            }}
            targetKeys={value}
            onChange={onChange}
            {...props}
        />
    );
};

export default AppTransfer;
